import RTE from './RTE'
export default RTE
export * from './RTE'

export { RTE as HtmlEditor }
